import React from "react";

const AboutPractice = () => {
  return (
    <div className="about-practice">
      <p className="lead">
        There's nothing like a beautiful smile.
      </p>
      <p>
        We invite you to visit our practice and become familiar with our caring,
        patient-centered approach to dentistry. Patients who have entrusted their
        dental care to Monument Dental quickly discover that we truly make our
        patients — and their families' comfort — our first priority.
      </p>
      <p>
        See for yourself how our modern equipment helps make us one of the most
        technologically advanced offices in the area. It enables us to be faster,
        less invasive, and more efficient while offering the highest level of
        dental care at an affordable cost to you.
      </p>
    </div>
  );
};

export default AboutPractice;
